import React, { useEffect, useState } from 'react'
import { Compass, Ship, ArrowRight, ChevronRight } from 'lucide-react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Swiper, SwiperSlide } from "swiper/react";
import {  Autoplay } from "swiper/modules";

import { Waves, Clock, Sparkles, Milestone, ShieldCheck } from 'lucide-react';
import {  Camera, Users, Sunset } from "lucide-react";
import {  Award,  Building2, Users2, Check, CheckCircle2, Star } from "lucide-react";
// import {    Sunset } from 'lucide-react';
import { Briefcase,   Shield } from 'lucide-react';


import FAQSection from '../Components/FAQSection';
import IndiaBoatsTopBar from '../Components/IndiaBoatsTopBar';
import PremiumNavbar from '../Components/PremiumNavbar';
import { Link } from 'react-router-dom';
import { getYachtDetailsPath } from '../utils/fleetCardSlug';

const corporateFaqs = [
  {
    question: "What types of corporate events does Indiaboats offer?",
    answer: "Indiaboats offers corporate sailing regattas, corporate yacht parties and corporate networking events in Mumbai."
  },
  {
    question: "What is a corporate sailing regatta?",
    answer: "A corporate sailing regatta is a team-building sailing experience where employees or business groups participate in a structured on-water activity designed to build teamwork, leadership and communication."
  },
  {
    question: "Is a yacht a good venue for a corporate party?",
    answer: "Yes. A yacht offers a more premium, private and memorable setting for company celebrations, annual gatherings and employee recognition events."
  },
  {
    question: "Why choose a yacht for a networking event?",
    answer: "A yacht creates a stronger business impression and offers a more distinctive environment for hosting clients, partners and executive guests."
  },
  {
    question: "Which corporate format is best for team building?",
    answer: "Corporate sailing regattas are usually the best choice for team building because they encourage active participation and collaboration."
  },
  {
    question: "Which corporate format is best for company celebrations?",
    answer: "Corporate yacht parties are usually the best choice for annual parties, festive gatherings and recognition-led events."
  },
  {
    question: "Which corporate format is best for client hosting and networking?",
    answer: "Corporate networking events on a yacht are usually the best fit for client hosting, partner interaction and premium business hospitality."
  },
  {
    question: "How do I enquire about a corporate event in Mumbai?",
    answer: "You can enquire through WhatsApp or the contact form and share your preferred date, guest count and event objective."
  }
];

const corporateCards = [
    {
      id: "corp-01",
      title: "Corporate Sailing Regattas",
      desc: "A powerful team-building experience on the water designed for communication, leadership and shared achievement. Ideal for active engagement.",
      ctaText: " Corporate Sailing Regattas",
      imgUrl: "assets/img/regatta1.png",
        link: "/corporate-sailing-regatta-mumbai",
      icon: <Compass size={22} />
    },
    {
      id: "corp-02",
      title: "Corporate Yacht Parties",
      desc: "A premium way to celebrate company milestones, annual events, festive gatherings and recognition-led occasions on exclusive private decks.",
      ctaText: " Corporate Yacht Parties",
      imgUrl: "assets/img/corporate_events4.png",
      link: "/corporate-party-awards-yacht-mumbai",
      icon: <Award size={22} />
    },
    {
      id: "corp-03",
      title: "Corporate Networking Events",
      desc: "A more exclusive setting for client hosting, business networking, partner gatherings and executive interaction with first-class services.",
      ctaText: " Corporate Networking Events",
      imgUrl: "assets/img/corporate_events1.png",
       link: "/corporate-events-networking-yacht-mumbai",
      icon: <Briefcase size={22} />
    }
  ];

  const featuresList = [
    {
      title: "Builds teamwork and communication",
      desc: "Requires real-time coordination and clear communication to maneuver on the water."
    },
    {
      title: "Creates stronger employee engagement",
      desc: "An active, shared adventure that breaks down corporate barriers and builds trust."
    },
    {
      title: "Encourages leadership and decision-making",
      desc: "Demands quick, calculated decisions under changing wind and tide conditions."
    },
    {
      title: "Offers a more memorable alternative to routine corporate outings",
      desc: "A distinctive offsite experience that guarantees lasting memory and impact."
    }
  ];

  const whyItMattersPoints = [
    {
      title: "Better Setting for Company Celebrations",
      desc: "An extraordinary marine backdrop that changes constantly, offering scenic harbor and sea views instead of static walls."
    },
    {
      title: "More Exclusive than Routine Venues",
      desc: "Complete privacy on your own private decks, ensuring your teams can celebrate without external distractions."
    },
    {
      title: "Strong Fit for Recognition & Festive Events",
      desc: "Perfectly designed to make annual milestones, reward ceremonies, and festivals feel uniquely rewarding."
    },
    {
      title: "Creates Stronger Recall & Guest Experience",
      desc: "An active, premium adventure on the Arabian Sea guarantees high engagement and long-lasting positive memory."
    }
  ];

  const highlights = [
    {
      title: "Premium corporate events in Mumbai",
      desc: "Top-tier maritime events executed flawlessly on the iconic Arabian Sea.",
      icon: <Award size={22} />
    },
    {
      title: "Regattas, Parties & Networking",
      desc: "A versatile suite of formats tailored precisely to your strategic business goals.",
      icon: <Ship size={22} />
    },
    {
      title: "Outperforms Hotel & Banquet Formats",
      desc: "An extraordinary marine environment that easily surpasses standard land venues.",
      icon: <Building2 size={22} />
    },
    {
      title: "Scenic Water Settings",
      desc: "Constant panoramic coastal views that change dynamically throughout your event.",
      icon: <Compass size={22} />
    },
    {
      title: "Built for Professional Groups",
      desc: "Perfectly optimized spaces for executive teams, high-profile clients, and partners.",
      icon: <Users2 size={22} />
    },
    {
      title: "Experience-Led Planning",
      desc: "Meticulous coordination, premium hospitality, and seamless operational management.",
      icon: <Sparkles size={22} />
    }
  ];



const CorporateEvents = () => {
  const [eventCards, setEventCards] = useState(corporateCards);
  const cardIcons = [<Compass size={22} />, <Award size={22} />, <Briefcase size={22} />];

  const getMediaUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/uploads/")) return path;
    return path;
  };

  useEffect(() => {
    fetch("/api/experiences/CorporateEvents")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.corporateCards?.length) {
          setEventCards(data.corporateCards);
        }
      })
      .catch((error) => console.error("Experience fetch error:", error));
  }, []);



    const businessNauticalOptions = [
    {
      type: "networking",
      badge: "RELATIONSHIP BUILDING",
      title: "Corporate Events & Networking",
      objective: "Client hosting, executive networking, premium hospitality, and business relationship-building",
      desc: "If your main objective is client hosting, executive networking, premium hospitality and business relationship-building, then a Corporate Events & Networking yacht format is usually the best fit.",
      linkText: "Corporate Yacht Events for Networking and Hosting",
      linkUrl: "#corporate-networking",
      icon: <Briefcase size={24} />
    },
    {
      type: "teambuilding",
      badge: "ACTIVE COLLABORATION",
      title: "Corporate Sailing Regattas",
      objective: "Team building, collaboration, leadership development, and active participation",
      desc: "If your main objective is team building, collaboration, leadership development and active participation, then a Corporate Sailing Regatta is usually more suitable.",
      linkText: "Corporate Sailing Regattas for Team Building",
      linkUrl: "#corporate-regattas",
      icon: <Compass size={24} />
    }
  ];




// Data object defined inside the component body for better maintainability.
  const ibBoatSelectorData = {
    title: "Which Boat Option Is Right for Your Trip",
    primaryParagraph: "The right boat for an Alibaug or Elephanta tour depends mainly on your group size, comfort preference and travel style.",
    secondaryParagraph: "For smaller private groups, couples and families, a speed boat or compact private transfer option is usually ideal. For bigger groups or premium outings, a larger private boat option may be more suitable depending on the number of guests and the style of travel you want.",
    ctaText: "Explore Private Speed Boat Transfers from Mumbai"
  };

  
  // Unique data structure for project-safe variable naming
  
  return (
    <>
        <IndiaBoatsTopBar/>
      <PremiumNavbar/>

          <div className="">
             <div className="">
     <section className="lch-hero-section">
      <div className="lch-container">
        
        {/* Simple Editorial Header Area */}
        <div className="lch-header-block">
          <h2 className="lch-section-title">
            Explore Corporate Event Experiences
          </h2>
        </div>

        {/* Static 3-Card Balanced Layout */}
        <div className="lch-cards-grid">
          {eventCards.map((card, index) => (
            <div key={card.title || index} className="lch-card">
              <div className="lch-card-top-accent"></div>
              
              {/* Card Image Frame (Height adjusted to 300px) */}
              <div className="lch-image-wrapper">
                <img 
                  src={getMediaUrl(card.imgUrl)} 
                  alt={card.title} 
                  className="lch-card-img" 
                />
                <div className="lch-img-overlay"></div>
                <div className="lch-icon-badge">
                  {cardIcons[index % cardIcons.length]}
                </div>
              </div>

              {/* Card Content Wrapper with Flex stretch alignments */}
              <div className="lch-card-content">
                <h3 className="lch-card-title">{card.title}</h3>
                <p className="lch-card-desc">{card.desc}</p>
                
                {/* Clean Button Section using the exact specified class markup */}
                <div className="lch-card-footer">
                 <Link to={card._id ? getYachtDetailsPath(card) : card.link || "#"}>
                  <button className="lyc-sleek-btn">
                    <span className="lyc-btn-text">{card.ctaText}</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                 </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
      </section>

      <section className="csr-main-section">
      <div className="csr-container">
        
        {}
        <div className="csr-split-grid">
          
          {/* Left Column: Editorial Header, Main Content & New Visual Showcase */}
          <div className="csr-content-column">
            
            
            <h2 className="csr-section-title">
              Corporate Sailing <span className="csr-light-text">Regattas</span>
            </h2>
            
            <div className="csr-accent-line"></div>
            
            <div className="csr-prose-block">
              <p className="csr-p-lead">
                A corporate sailing regatta in Mumbai is one of the most engaging team-building formats a company can organise. Instead of a routine offsite or passive outing, teams take part in a live sailing experience that encourages communication, coordination, leadership and shared achievement.
              </p>
              <p className="csr-p-body">
                This format is especially valuable for businesses that want employee engagement, leadership development and stronger team connection. It feels more active, more memorable and more meaningful because people are participating together rather than simply attending an event.
              </p>
            </div>

            {}
            {/* New Elegant Visual Block for balancing layout proportions */}
            <div className="csr-image-wrapper">
              <img 
                src="/assets/img/regatta5.png" 
                alt="Corporate yacht racing teams working in perfect coordination on Mumbai waters" 
                className="csr-regatta-img" 
              />
              <div className="csr-image-overlay"></div>
              <div className="csr-image-badge">
                <Compass size={12} className="csr-badge-icon" />
                <span>Mumbai Harbour</span>
              </div>
            </div>
          </div>

          {/* Right Column: Why It Matters Detailed Panel */}
          <div className="csr-matters-panel">
            <div className="csr-panel-accent"></div>
            
            <div className="csr-panel-header">
              <Star size={18} className="csr-star-icon" />
              <h3 className="csr-panel-title">Why It Matters</h3>
            </div>

            <div className="csr-points-stack">
              {featuresList.map((item, index) => (
                <div key={index} className="csr-point-item">
                  <div className="csr-icon-wrapper">
                    <CheckCircle2 size={16} className="csr-check-icon" />
                  </div>
                  <div className="csr-point-content">
                    <h4 className="csr-point-title">{item.title}</h4>
                    <p className="csr-point-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
      </section>



     
      </div>

      <section className="cyp-main-section">
      <div className="cyp-container">
        
        {}
        <div className="cyp-editorial-header">
          
          
          <h2 className="cyp-section-title">
            Corporate Yacht <span className="cyp-serif-italic">Parties</span>
          </h2>
          <div className="cyp-header-divider"></div>
        </div>

        {}
        <div className="cyp-editorial-grid">
          
          {/* Left Panel: Why It Matters Column now styled in flagship theme bg */}
          <div className="cyp-benefits-panel">
            <div className="cyp-benefits-header">
              <Milestone size={18} className="cyp-milestone-icon" />
              <h3 className="cyp-benefits-title">Why It Matters</h3>
            </div>

            <div className="cyp-benefits-grid">
              {whyItMattersPoints.map((point, index) => (
                <div key={index} className="cyp-benefit-card">
                  <div className="cyp-card-top-bar"></div>
                  
                  <div className="cyp-card-header">
                    {/* Numbers removed; clean themed check remains */}
                    <ShieldCheck size={16} className="cyp-check-icon" />
                  </div>
                  
                  <h4 className="cyp-card-title">{point.title}</h4>
                  <p className="cyp-card-desc">{point.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Panel: Primary Narrative Column & Quote Block */}
          <div className="cyp-narrative-panel">
            <div className="cyp-prose-block">
              <p className="cyp-p-lead">
                A corporate yacht party in Mumbai offers a more memorable and premium setting for company celebrations than a standard hotel or banquet venue. It is ideal for annual parties, festive gatherings, company milestones, reward events and internal celebrations that should feel more special and more exclusive.
              </p>
              
              <p className="cyp-p-body">
                The private setting on the water creates a stronger sense of occasion and gives teams a more enjoyable and rewarding experience. For companies, it is a powerful way to celebrate culture, recognise people and create positive internal memories.
              </p>
            </div>

            {/* Premium Brand Styled Quote Callout */}
            <div className="cyp-quote-box">
              <span className="cyp-quote-bracket">“</span>
              <p className="cyp-quote-text">
                An exceptional way to honor achievements, foster brand loyalty, and host clients on Mumbai's iconic harbour waters.
              </p>
              <div className="cyp-quote-author">
                <div className="cyp-quote-line"></div>
                <span>India Boats Experience Guarantee</span>
              </div>
            </div>
          </div>

        </div>

        {}
        <div className="cyp-action-strip">
          <div className="cyp-action-text-group">
            <span className="cyp-action-accent">Bespoke Customization</span>
            <p className="cyp-action-para">From customized dining menus to live music configurations, we build the perfect party deck.</p>
          </div>
          <Link to="/corporate-party-awards-yacht-mumbai" className="cyp-sleek-btn">
  <span>Explore Celebration Yachts</span>
  <div className="cyp-btn-circle">
    <ArrowRight size={14} />
  </div>
</Link>
        </div>

      </div>
      </section>

     

 {/* <section className="aeb-better-section">
      <div className="aeb-container">
        <div className="aeb-better-grid">
          
          
          <div className="aeb-better-content-col">
            
            <h2 className="aeb-better-section-title">
              Why Corporate Yacht Events Feel More Premium and Memorable
            </h2>
            
            <div className="aeb-better-paragraphs">
              <p className="aeb-better-p">
               A corporate yacht event feels different because the setting itself elevates the experience. Guests are not entering a routine venue — they are stepping into a private environment on the water with sea views, skyline backdrops and a more exclusive atmosphere.
              </p>
              <p className="aeb-better-p">
                This changes the quality of the event. Conversations feel more relaxed but still premium. Client hosting feels more thoughtful. Networking feels more natural. Leadership gatherings feel more elevated. The event becomes easier to remember because the setting is more distinctive than ordinary business venues.
              </p>
             
            </div>

            
            <div className="aeb-highlight-banner">
              <Sparkles className="aeb-highlight-icon" size={24} />
              <p className="aeb-highlight-banner-text">
                Better setting, better conversations, stronger impressions.
              </p>
            </div>
          </div>

         
          <div className="aeb-better-features-col">
            <div className="aeb-feature-visual-card">
              <img 
                src="https://images.unsplash.com/photo-1562281302-809108fd533c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                alt="Private luxury speedboat on open sea with wake" 
                className="aeb-feature-img"
              />
              
              <div className="aeb-amenities-stack">
                <div className="aeb-amenity-pill">
                  <Waves className="aeb-pill-svg" size={16} />
                  <span>No Road Congestion</span>
                </div>
                <div className="aeb-amenity-pill">
                  <Clock className="aeb-pill-svg" size={16} />
                  <span>Direct Open Water Routes</span>
                </div>
                <div className="aeb-amenity-pill">
                  <Compass className="aeb-pill-svg" size={16} />
                  <span>Exclusive Group Setting</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      </section>

       

      <section className="tds-main-section">
  <div className="tds-container">
    
   
    <div className="tds-top-split-grid">
      <div className="tds-content-column">
        <div className="tds-tag-wrapper">
          <Waves size={12} className="tds-icon" />
          <span className="tds-pre-title">Corporate Solutions</span>
        </div>
        <h2 className="tds-section-title">
          What You Can Do During a <span className="tds-light-text">Corporate Yacht Event or Networking Experience</span>
        </h2>
      </div>
      
      <div className="tds-intro-column">
        <p className="tds-p">
          Corporate yacht events in Mumbai can be styled in different ways depending on the purpose of the gathering. Some businesses want a premium networking environment, while others want a hosted client experience or a leadership evening with stronger hospitality value.
        </p>
      </div>
    </div>

    
    <div className="tds-highlights-grid">
      {[
        { title: "Premium Venue Hosting", desc: "Host clients and partners in a premium private venue." },
        { title: "Strategic Networking", desc: "Plan business networking on a yacht with ease." },
        { title: "Leadership Gatherings", desc: "Organise exclusive leadership or executive gatherings." },
        { title: "High-Stakes Meets", desc: "Hold founder, investor or partner meets." },
        { title: "Client Appreciation", desc: "Create bespoke client appreciation and relationship-building experiences." },
        { title: "Reward & Recognition", desc: "Plan impactful reward and recognition events for senior teams." },
        { title: "Scenic Hospitality", desc: "Combine networking with scenic cruising and premium hospitality." },
        { title: "Business on Water", desc: "Create memorable hosted business events on the water." }
      ].map((item, index) => (
        <div key={index} className="tds-card">
          <div className="tds-card-top-accent"></div>
          <div className="tds-card-icon-box">
            {index % 4 === 0 && <Ship size={20} />}
            {index % 4 === 1 && <Camera size={20} />}
            {index % 4 === 2 && <Users size={20} />}
            {index % 4 === 3 && <Sunset size={20} />}
          </div>
          <h5 className="tds-card-title">{item.title}</h5>
          <p className="tds-card-desc">{item.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>

    <section className="exp-section">
  <div className="exp-container">
    
    
    <div className="exp-header">
      <h2 className="exp-title">What the Experience Feels Like</h2>
      <div className="exp-divider"></div>
    </div>

    
    <div className="exp-content">
      <p className="exp-main-text">
        A corporate yacht event feels elegant, exclusive and more thoughtfully hosted than a routine business gathering. The atmosphere is more open, the surroundings are more memorable and the quality of time spent with guests often feels better because the environment is more premium and less conventional.
      </p>

      <div className="exp-sub-grid" id='corporate_exp_grid'>
        <div className="exp-card">
          <h4 className="exp-card-title">For Clients & Partners</h4>
          <p className="exp-card-text">
            The experience feels impressive and distinctive, helping you build stronger professional relationships.
          </p>
        </div>
        <div className="exp-card">
          <h4 className="exp-card-title">For Leadership</h4>
          <p className="exp-card-text">
            It feels elevated and refined, providing a sophisticated backdrop for key executive interactions.
          </p>
        </div>
        <div className="exp-card">
          <h4 className="exp-card-title">Internal Gatherings</h4>
          <p className="exp-card-text">
            It feels more rewarding and more memorable than a standard venue-based event.
          </p>
        </div>
      </div>

      <p className="exp-footer">
        With <strong>Indiaboats</strong>, the experience is about more than the yacht itself — it is about using the right setting to create stronger business impressions and better event value.
      </p>
    </div>
  </div>
</section>

      <section className="ib-luxury-feature-wrapper">
  <div className="ib-luxury-feature-container">
    <div className="ib-luxury-feature-main-content">
      <h2 className="ib-luxury-feature-headline">
        Why Plan Corporate Events & Networking with <span className="ib-luxury-feature-text-accent">Indiaboats</span>
      </h2>
      <p>
        <span className="ib-luxury-feature-text-accent">Indiaboats</span> offers premium yacht experiences in Mumbai and helps companies create corporate events and networking formats that feel smooth, memorable and professionally hosted. We understand that business events should not only look premium, but also support relationship-building, guest comfort and brand impression.
      </p>
      <p>From helping you choose the right yacht format to guiding you toward the best experience for your audience, Indiaboats makes it easier to create business gatherings that feel elevated from the start.</p>
    </div>

    <div className="ib-luxury-feature-grid">
      {[
    { title: "Premium Events", desc: "Premium corporate yacht event experiences in Mumbai.", icon: <Ship size={24} /> },
    { title: "Networking Ready", desc: "Ideal for client hosting and business networking.", icon: <Users size={24} /> },
    { title: "Executive Focus", desc: "Strong fit for leadership and executive gatherings.", icon: <Award size={24} /> },
    { title: "Beyond Conventional", desc: "More memorable than conventional venues.", icon: <MapPin size={24} /> },
    { title: "Exclusive Setting", desc: "Scenic and exclusive on-water environment.", icon: <Anchor size={24} /> },
    { title: "Expert Execution", desc: "Experience-led planning and premium execution.", icon: <Settings size={24} /> },
    { title: "High Value", desc: "Better hospitality and business impression value.", icon: <Sparkles size={24} /> }
  ].map((item, index) => (
        <div key={index} className="ib-luxury-feature-card">
          <div className="ib-luxury-feature-icon-box">{item.icon}</div>
          <div className="ib-luxury-feature-card-content">
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      <section className="ib-boat-selector-wrapper">

      <div className="ib-boat-selector-container">
        <h2 className="ib-boat-selector-headline">{ibBoatSelectorData.title}</h2>
        <p className="ib-boat-selector-text">{ibBoatSelectorData.primaryParagraph}</p>
        <p className="ib-boat-selector-text">{ibBoatSelectorData.secondaryParagraph}</p>

        <a href="#" className="ib-boat-selector-cta-block">
          <span className="ib-boat-selector-cta-text">{ibBoatSelectorData.ctaText}</span>
          <svg className="ib-boat-selector-icon" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </div>
    </section>

     <section className="pfUniqueMainSection">
  <div className="pfUniqueContainer">
    
   
    <div className="pfUniqueHeader" style={{ marginBottom: '2rem' }}>
      <h2 className="pfUniqueHeading">
        Who Corporate Yacht Events <span>Are Best For</span>
      </h2>
      <p className="pfUniqueSubtext" style={{ marginTop: '1rem', color: '#666' }}>
        Corporate events and networking on a yacht in Mumbai are ideal for businesses that want a stronger setting for hosting, relationship-building and brand-led hospitality.
      </p>
    </div>

    
    <div className="pfUniqueGridWrapper">
      {[
        "Client appreciation events",
        "Partner and investor gatherings",
        "Business networking evenings",
        "Executive and leadership hosting",
        "Founder and CXO meetings",
        "Premium reward and recognition events",
        "Corporate hospitality experiences",
        "Internal business celebrations with a premium feel"
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>

<section className="cxe-main-section">
      <div className="cxe-container">
        
       
        <div className="cxe-header-block">
          <div className="cxe-tag-row">
            <Shield size={14} className="cxe-shield-icon" />
            <span className="cxe-pre-title">Decision Framework</span>
          </div>
          <h2 className="cxe-section-title">
            Which Corporate Experience <span className="cxe-light-text">Is Right for Your Business</span>
          </h2>
          <p className="cxe-section-subtitle">
            Align your strategic organizational outcomes with our curated world-class marine formats.
          </p>
        </div>

        
        <div className="cxe-decision-grid">
          {businessNauticalOptions.map((option, index) => {
            const isNetworking = option.type === "networking";
            return (
              <div 
                key={index} 
                className={`cxe-decision-card ${isNetworking ? 'cxe-card-dark' : 'cxe-card-light'}`}
              >
                <div className="cxe-card-accent-line"></div>
                
                <div className="cxe-card-header">
                  <div className="cxe-icon-box">
                    {option.icon}
                  </div>
                  <span className="cxe-card-badge">{option.badge}</span>
                </div>

                <div className="cxe-card-body">
                  <h3 className="cxe-card-title">{option.title}</h3>
                  <p className="cxe-card-desc">{option.desc}</p>
                </div>

                <div className="cxe-card-footer">
                  <a href={option.linkUrl} className="cxe-anchor-link">
                    <span>{option.linkText}</span>
                    <div className="cxe-arrow-wrapper">
                      <ArrowRight size={16} />
                    </div>
                  </a>
                </div>
              </div>
            );
          })}
        </div>

      </div>
      </section>

      <section className="yev-main-section">
      <div className="yev-container">
        
        <div className="yev-split-grid">
          
        
          <div className="yev-title-column">
            <div className="yev-tag-wrapper">
              <Anchor size={14} className="yev-anchor-icon" />
              <span className="yev-pre-title">Strategic Distinction</span>
            </div>
            
            <h2 className="yev-section-title">
              Why Companies Choose Yacht Events <span className="yev-light-text">Over Standard Venues</span>
            </h2>
            
            <div className="yev-accent-line"></div>
          </div>

         
          <div className="yev-prose-column">
            <p className="yev-paragraph-lead">
              Many businesses choose corporate yacht events in Mumbai because they create stronger recall value and better guest experience than standard land-based venues. A yacht feels more premium, more distinctive and more aligned with businesses that want to host well and stand out.
            </p>
            
            <p className="yev-paragraph-body">
              It helps turn an event into a true experience, which is especially valuable when the objective is to build relationships, strengthen brand perception or create memorable business moments.
            </p>

            <div className="yev-cta-wrapper">
              <button className="yev-text-cta">
                <span>Explore Corporate Charter Formats</span>
                <ArrowRight size={16} />
              </button>
            </div>
          </div>

        </div>

      </div>
      </section>

      <section className="wteUniqueMainSection">
  <div className="wteUniqueContainer">
    <div className="wteUniqueContentWrapper">
      <div className="wteUniqueLeftContent">
        <span className="wteUniqueMiniTitle">
          WHAT TO EXPECT
        </span>

        <h2 className="wteUniqueHeading">
          What to Expect with <span>Indiaboats</span>
        </h2>

        <p className="wteUniqueParagraph">
          When you plan a corporate yacht event with Indiaboats, the experience is designed to feel premium, smooth and well thought through. We help businesses understand which format suits their audience, which type of gathering they want to create and how to make the experience feel more valuable from the guest perspective.
        </p>
      </div>

      <div className="wteUniqueRightContent">
        {[
          "Premium yacht event experience in Mumbai",
          "Guidance based on audience and event objective",
          "Strong fit for hosting and networking",
          "Scenic and memorable on-water setting",
          "More premium than ordinary venues",
          "Supportive and experience-led planning"
        ].map((item, index) => (
          <div className="wteUniqueListCard" key={index}>
            <div className="wteUniqueCheckCircle">✓</div>
            <p className="wteUniqueListText">{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section> */}

<div className="cne-section">
      <div className="cne-container">
        
        { }
        <div className="cne-editorial-grid">
          
          {/* Left Column: Title, Prose Narrative, and Highlights Grid */}
          <div className="cne-content-panel">
            
            <div className="cyp-section-title">
              Corporate Networking <span className="cyp-serif-italic">
                Events
              </span>
            </div>
            
            <div className="cne-divider"></div>
            
            <div className="cne-prose-block">
              <div className="cne-p-lead">
                A corporate networking event on a yacht gives businesses a premium and distinctive setting for client hosting, partner interaction, investor meetings and executive networking. Instead of a routine restaurant or banquet venue, guests experience a private atmosphere on the water that feels more polished and more memorable.
              </div>
              
              <div className="cne-p-body">
                This format works especially well for businesses that want to build stronger relationships, host with more style and create better brand impression through premium hospitality.
              </div>
            </div>

           

          </div>

          {/* Right Column: Premium Visual Showcase Panel */}
          <div className="cne-image-panel">
            <div className="cne-image-frame">
              <img 
                src="/assets/img/ce_bg.png" 
                alt="Corporate business professionals networking on a luxury yacht deck" 
                className="cne-showcase-img"
              />
              <div className="cne-image-overlay"></div>
              
              <div className="cne-floating-badge">
                <Briefcase size={14} className="cne-badge-icon" />
                <span className="cne-badge-label">Executive Yacht Experience</span>
              </div>
            </div>
          </div>

        </div>
         {/* Why It Matters Highlights Panel */}
            <div className="cne-matters-card">
              <div className="cne-matters-title">Why It Matters</div>
              
              <div className="cne-matters-grid">
                {[
                  "Stronger setting for business networking",
                  "Better for client hosting and partner interaction",
                  "Creates a more premium business impression",
                  "More memorable than conventional venues"
                ].map((point, index) => (
                  <div key={index} className="cne-benefit-item">
                    <div className="cne-icon-container">
                      <CheckCircle2 size={18} className="cne-check-icon" />
                    </div>
                    <div className="cne-benefit-text">{point}</div>
                  </div>
                ))}
              </div>
            </div>

      </div>
      </div>

       <section className="wcce-main-section">
      <div className="wcce-container">
        
        <div className="wcce-split-grid">
          
          {/* Left Column: Editorial Header and Narrative Copy */}
          <div className="wcce-content-panel">
            
            
            {/* Using the pre-existing global .cyp-section-title precisely as requested */}
            <h2 className="cyp-section-title">
              Why Choose <span className="wcce-serif-italic">Indiaboats</span> <br />
              for Corporate Events
            </h2>
            
            <div className="wcce-header-divider"></div>
            
            <div className="wcce-prose-block">
              <p className="wcce-p-lead">
                Indiaboats offers premium corporate event experiences in Mumbai designed to feel smooth, memorable and professionally managed. Whether your goal is team building, celebration or business networking, we help you choose the right format for your company and your guests.
              </p>
              
              <p className="wcce-p-body">
                Our focus is on creating corporate events that are not only visually impressive, but also easy to plan and valuable for the people attending. From corporate sailing regattas to corporate yacht parties and corporate networking events, Indiaboats helps businesses create stronger experiences on the water.
              </p>
            </div>

            {/* Quick trust metrics */}
            <div className="wcce-trust-bar">
              <div className="wcce-trust-item">
                <Check size={16} className="wcce-trust-check" />
                <span>Zero-Failure Operations</span>
              </div>
              <div className="wcce-trust-item">
                <Check size={16} className="wcce-trust-check" />
                <span>Professional Skipper Crew</span>
              </div>
            </div>
          </div>

          {/* Right Column: Highlights Bento/Grid Layout */}
          <div className="wcce-highlights-panel">
            <div className="wcce-grid-pattern"></div>
            
            <div className="wcce-cards-grid">
              {highlights.map((item, index) => (
                <div key={index} className="wcce-highlight-card">
                  <div className="wcce-card-top-accent"></div>
                  
                  <div className="wcce-card-icon-wrapper">
                    {item.icon}
                  </div>
                  
                  <div className="wcce-card-content">
                    <h3 className="wcce-card-title">{item.title}</h3>
                    <p className="wcce-card-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
      </section>

     <section className="scUniqueMainSection" id='cp_safety'>
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <br /> <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
           At Indiaboats, safety is central to every corporate yacht event. We place strong emphasis on trained crew, responsible operations, guest comfort and professional coordination so your business gathering feels smooth, premium and well managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  pageKey="CorporateEvents"
  title="Frequently Asked Questions About Corporate Events in Mumbai"
  faqData={corporateFaqs}
/>

 {/* <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

        

          <h2 className="igxMainHeading">
            Host a Corporate Event That Makes a 
            <span> Stronger Impression</span>
          </h2>

          <p className="igxParagraphText">
            Discover how business networking and corporate hosting on a yacht in Mumbai can create more memorable, premium and effective business gatherings with Indiaboats.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Plan Your Corporate Event</span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Explore Corporate Sailing Regattas</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Request a Proposal</span>
            </button>

          </div>
        </div>
      </div>
    </section> */}

     <section className="btfUniqueSection" id='corporate_e_form'>
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Business Event</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Company Name</label>
      <input type="text" placeholder="Enter company name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Event Objective</label>
      <select>
        <option>Select event objective</option>
        <option>Client Appreciation</option>
        <option>Networking Evening</option>
        <option>Leadership Gathering</option>
        <option>Partner/Investor Meet</option>
        <option>Reward & Recognition</option>
        <option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your corporate event requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Proposal</span>
  </button>
</form>
        </div>
      </div>
    </section>

            </div>


<Footer/>
</>
  )
}

export default CorporateEvents
